import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=5919c45e&scoped=true&"
import script from "./ViewProduct.vue?vue&type=script&lang=ts&"
export * from "./ViewProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=5919c45e&lang=scss&scoped=true&"
import style1 from "./ViewProduct.vue?vue&type=style&index=1&id=5919c45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919c45e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCard,VCol,VContainer,VContent,VIcon,VNavigationDrawer,VRow,VTextField})
